import { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function BlogDetailPage() {
  const { id } = useParams();
  const [blog, setBlog] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchBlog();
  }, [id]);

  const fetchBlog = async () => {
    try {
      const res = await fetch(`${API}/blogs/${id}`);
      if (res.ok) {
        setBlog(await res.json());
      }
    } catch (e) {
      console.error("Error fetching blog:", e);
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (dateStr) => {
    return new Date(dateStr).toLocaleDateString('en-US', {
      weekday: 'long',
      month: 'long',
      day: 'numeric',
      year: 'numeric'
    });
  };

  return (
    <div className="page-wrapper" data-testid="blog-detail-page">
      <div className="myspace-container">
        {/* Header */}
        <div className="myspace-header">
          <h3>kezzio's blog</h3>
        </div>

        <div className="myspace-section m-2">
          <div className="myspace-section-title">
            <Link to="/blog" className="text-[var(--text-link)] no-underline" data-testid="back-to-blog">
              &laquo; Back to Blog
            </Link>
          </div>
          <div className="myspace-section-content">
            {loading ? (
              <div className="text-[var(--text-white)] opacity-80 text-[11px]">Loading...</div>
            ) : blog ? (
              <div className="blog-entry-2006" data-testid="blog-article">
                <div className="blog-title">{blog.title}</div>
                <div className="blog-date">{formatDate(blog.created_at)}</div>
                <div className="blog-content whitespace-pre-wrap">
                  {blog.content}
                </div>
              </div>
            ) : (
              <div className="text-[var(--text-white)] opacity-80 text-[11px]">Blog not found</div>
            )}
          </div>
        </div>

        {/* Footer */}
        <div className="text-center text-[10px] text-[var(--text-white)] opacity-50 py-3 border-t border-[var(--border-color)]">
          <a href="/" className="text-[var(--text-link)]">&laquo; Back to Home</a>
        </div>
      </div>
    </div>
  );
}
